import { formatCurrencyAmountWithIssue } from '../../../commons/currency/Currency.Functions';
import { connect } from 'react-redux';

// functions
import * as ComponentFunctions from './SettlementTotalItem.Functions';

// styles
import './SettlementTotalItem.Styles.css';

const fmt = (value: number | undefined, currency: string) => formatCurrencyAmountWithIssue(value, currency);

const SettlementTotalItemComponent = (props: ComponentFunctions.Props) => {
    const cur = props.CurrencyCode?.toUpperCase() || 'ARS';

    const totalALiquidar   = props.TotalToSettle    ?? 0;
    const honorariosCentro = props.OwnerAmount        ?? 0;
    const honorariosEquipo = props.TeamAmount         ?? 0;
    const retencionTotal   = props.TotalWithholdings  ?? 0;
    const retencionCentro  = props.OwnerWithholdings  ?? 0;
    const retencionEquipo  = props.TeamWithholdings   ?? 0;
    const totalACobrar     = totalALiquidar - honorariosEquipo - retencionCentro;

    return (
        <div className="sti-card">
            <div className="sti-currency-badge">{cur}</div>
            <table className="sti-table">
                <tbody>

                    {/* ── Composición del total a liquidar ────────────── */}
                    <tr className="sti-bruto-row">
                        <td className="sti-label">Total a liquidar</td>
                        <td className="sti-amount">{fmt(totalALiquidar, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Honorarios centro médico</td>
                        <td className="sti-amount">{fmt(honorariosCentro, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Honorarios equipo médico</td>
                        <td className="sti-amount">{fmt(honorariosEquipo, cur)}</td>
                    </tr>

                    {/* ── Composición de la retención ──────────────────── */}
                    <tr className="sti-retention-header">
                        <td className="sti-label">Retención total</td>
                        <td className="sti-amount">{fmt(retencionTotal, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Retención centro médico</td>
                        <td className="sti-amount">{fmt(retencionCentro, cur)}</td>
                    </tr>
                    <tr className="sti-sub">
                        <td className="sti-label">Retención equipo médico</td>
                        <td className="sti-amount">{fmt(retencionEquipo, cur)}</td>
                    </tr>

                    {/* ── Deducciones para el total a cobrar ───────────── */}
                    <tr className="sti-deduct sti-deduct-first">
                        <td className="sti-label">Honorarios equipo médico</td>
                        <td className="sti-amount sti-neg">− {fmt(honorariosEquipo, cur)}</td>
                    </tr>
                    <tr className="sti-deduct">
                        <td className="sti-label">Retención centro médico</td>
                        <td className="sti-amount sti-neg">− {fmt(retencionCentro, cur)}</td>
                    </tr>

                    {/* ── Total a cobrar ───────────────────────────────── */}
                    <tr className="sti-grand-total">
                        <td className="sti-label">Total a cobrar</td>
                        <td className="sti-amount sti-pos">{fmt(totalACobrar, cur)}</td>
                    </tr>

                </tbody>
            </table>
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementTotalItemComponent as any);